import {createContext, useContext} from 'react'
import type {Schedule} from '../types/domain'
import type {SessionSnapshot, TimerSnapshot} from './domain/timerSnapshot'

export type TimerSegment = Pick<TimerSnapshot, 'levelIndex' | 'breakIndex' | 'onBreak'>

export interface SessionControls {
  session: SessionSnapshot | null
  status: 'Standalone' | 'Hosting' | 'View only' | 'Recovering' | 'Legacy'
  syncStatus: 'Synced' | 'Pending' | 'Unsynced'
  serverNowMs: number
  availableAtMs: number | null
  error: string | null
  busy: boolean
  canControl: boolean
  canResume: boolean
  hostGeneration?: number | null
  toggle(): void
  reset(segment?: TimerSegment): void
  skip(segment?: TimerSegment): void
  startSchedule(schedule: Schedule, onStarted: () => void): void
  create(): Promise<void>
  remove(): Promise<void>
  resume(expectedGeneration?: number): Promise<void>
  retire(): Promise<void>
  retry(): Promise<void>
}

export const SessionContext = createContext<SessionControls | null>(null)
export function useSessionControls() {
  const value = useContext(SessionContext)
  if (!value) throw new Error('A session coordinator is required.')
  return value
}
